import Styled from "styled-components";

export const MainContainer = Styled("div") < { gutter?: number }> `
  ${(props) => {
    const { breakpoints } = props.theme;
    const { margin, gutter, maxWidth } = props.theme.grid;

    let styles = `
      width: 100%;
      padding-right: ${props.gutter / 2 || gutter / 2}px;
      padding-left: ${props.gutter / 2 || gutter / 2}px;
      margin-right: auto;
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      @media ( max-width: 767px ) {
        padding-right: ${gutter / 2}px;
        padding-left: ${gutter / 2}px;
      }
    `;

    Object.keys(breakpoints).forEach((breakpoint) => {
      styles += `
        @media ( min-width: ${breakpoints[breakpoint]} ) {
          max-width: ${maxWidth[breakpoint]};
        }
      `;
    });

    return styles;
  }}
`;
